import * as firebase from 'firebase';

let config = {
	apiKey: "AIzaSyAKF9W7dnDzYgqw6kOswdLrxqCqKeIboZQ",
	authDomain: "sc-laning-tools.firebaseapp.com",
	databaseURL: "https://sc-laning-tools.firebaseio.com",
	projectId: "sc-laning-tools",
	storageBucket: "sc-laning-tools.appspot.com",
	messagingSenderId: "393444694521"
};
firebase.initializeApp(config);
let db = firebase.database();

export default class FirebaseClient{

	static getDb(){
		return db;
	}


	static updateFromRootP(update:any):Promise<any>{
		return (db.ref().update(update) as Promise<any>);
	}

}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/framework/FirebaseClient.ts